module.exports = __webpack_public_path__ + "static/media/6235.9991b477.jpg";